import Carousel from '@lyra/core/components/Carousel'
import Responsive from '@lyra/core/components/Responsive'
import Section, { SectionProps } from '@lyra/core/components/Section'
import NextLinkUnstyled from '@lyra/web/components/common/NextLinkUnstyled'
import { ANNOUNCEMENTS } from '@lyra/web/constants/announcements'
import { LOCAL_STORAGE_ANNOUNCEMENTS_KEY } from '@lyra/web/constants/localStorage'
import useLocalStorage from '@lyra/web/hooks/local_storage/useLocalStorage'
import { useCallback, useMemo } from 'react'
import { XStack } from 'tamagui'

import HomeAnnouncementCard from './HomeAnnouncementCard'

type Props = SectionProps

const CARD_HEIGHT = 180
const CARD_WIDTH = 320

const HomeAnnouncementsSection = ({ ...sectionProps }: Props) => {
  const [_dismissedState, _setDismissedState] = useLocalStorage(LOCAL_STORAGE_ANNOUNCEMENTS_KEY)

  const dismissedAnnouncementIds: Record<string, boolean> = useMemo(
    () => (_dismissedState ? JSON.parse(_dismissedState) : {}),
    [_dismissedState]
  )

  const handleDismissAnnouncement = useCallback(
    (id: string) => {
      _setDismissedState(JSON.stringify({ ...dismissedAnnouncementIds, [id]: true }))
    },
    [dismissedAnnouncementIds, _setDismissedState]
  )

  // limit to 4 announcements
  const announcementsList = useMemo(
    () => ANNOUNCEMENTS.filter((a) => !dismissedAnnouncementIds[a.id]).slice(0, 4),
    [dismissedAnnouncementIds]
  )

  if (!announcementsList.length) {
    return null
  }

  const announcementCards = announcementsList.map((announcement) => (
    <NextLinkUnstyled key={announcement.id} href={announcement.href}>
      <HomeAnnouncementCard
        announcement={announcement}
        onDismiss={() => handleDismissAnnouncement(announcement.id)}
        flexGrow={1}
        flexShrink={1}
        minHeight={180}
        maxHeight={240}
        minWidth={280}
        maxWidth={360}
      />
    </NextLinkUnstyled>
  ))

  return (
    <Section {...sectionProps}>
      <Section.Header title="Announcements" />
      <Section.XStack>
        <Responsive
          width="100%"
          desktop={
            <XStack gap="$3" width="100%" style={{ overflowX: 'scroll' }}>
              {announcementCards}
            </XStack>
          }
          mobile={<Carousel>{announcementCards}</Carousel>}
        />
      </Section.XStack>
    </Section>
  )
}
export default HomeAnnouncementsSection
